import React, { useMemo, useState, useEffect } from 'react'
import { Container, Top } from '../../../../styles'
import { DefaultUserPage } from '../../../../../DefaultPages'
import { BoxButtonsHead } from './styles'
import { CompanyCertificatesTabs } from '../../../../../../constants/order'

import { Breadcrumbs, InsideFooter, Tab } from '../../../../../../components'
import Pillars from './Pillars'
import Users from './Users'
import Files from './Files'
import LocalStorageService from '../../../../../../services/LocalStorageService'
import { Roles } from '../../../../../../constants/roles'
import { useQuery } from 'react-query'
import ecbrApi from '../../../../../../services/ecbrApi'
import { CertificateStatus } from '../../../../../../constants/certificate'
import useUrlParam from '../../../../../../hooks/useUrlParam'

const UserCertificateDetails = () => {
  const [_brandId, certificateId] = useUrlParam(
    '/user/brands/:id/certificates/:id'
  )
  const [tabName, setTabName] = useState(null)
  const user = LocalStorageService.get('user')
  const [showTabs, setShowTabs] = useState({
    pillars: false,
    users: false,
    files: false
  })
  const [error, setError] = useState(null)

  const userRole = useMemo(() => {
    return user?.role
  }, [user])

  const { data: certificate } = useQuery(
    'certificate',
    async () => {
      const { data } = await ecbrApi.certificates.getById(certificateId)
      return data
    },
    {
      refetchOnWindowFocus: false,
      onSuccess: () => {
        setError(null)
      },
      onError: () => {
        setError('Não foi possível carregar os dados do certificado')
      }
    }
  )

  useEffect(() => {
    if (certificate?.status === CertificateStatus.ACTIVE) {
      setShowTabs({
        pillars: false,
        users: true,
        files: true
      })
      setTabName(CompanyCertificatesTabs.FILES)
    } else {
      setShowTabs({
        pillars: true,
        users: true,
        files: true
      })
      setTabName(CompanyCertificatesTabs.PILLARS)
    }
  }, [certificate])

  return (
    <DefaultUserPage page="brands">
      <Container>
        <Top>
          <Breadcrumbs />

          <BoxButtonsHead>
            {/* <Button
              type="button"
              variant="outlined"
              text="Exportar excel"
              width="120px"
            /> */}
            {/* <Button
              type="button"
              variant="primary"
              text="Bloquear"
              width="120px"
            /> */}
          </BoxButtonsHead>
        </Top>
        <h3>Responda ao questionário para obter a sua certificação</h3>

        {error && <span>{error}</span>}
        {!error && (
          <>
            <Tab>
              {showTabs.pillars && (
                <Tab.Item
                  name="tabName"
                  label="Pilares"
                  onClick={() => setTabName(CompanyCertificatesTabs.PILLARS)}
                  checked={tabName === CompanyCertificatesTabs.PILLARS}
                />
              )}
              {userRole !== Roles.PILLAR_OWNER && (
                <>
                  {showTabs.users && (
                    <Tab.Item
                      name="tabName"
                      label="Usuários"
                      onClick={() => setTabName(CompanyCertificatesTabs.USERS)}
                      checked={tabName === CompanyCertificatesTabs.USERS}
                    />
                  )}
                  {showTabs.files && (
                    <Tab.Item
                      name="tabName"
                      label="Certificados"
                      onClick={() => setTabName(CompanyCertificatesTabs.FILES)}
                      checked={tabName === CompanyCertificatesTabs.FILES}
                    />
                  )}
                </>
              )}
            </Tab>

            {tabName === CompanyCertificatesTabs.PILLARS && <Pillars />}
            {tabName === CompanyCertificatesTabs.USERS && <Users />}
            {tabName === CompanyCertificatesTabs.FILES && <Files />}
          </>
        )}
        <InsideFooter />
      </Container>
    </DefaultUserPage>
  )
}

export default UserCertificateDetails
